import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Hero from '../../components/hero/hero';
import PainPoints from '../../components/PainPoints/PainPoints';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import ResultsSection from '../../components/ResultsSection/ResultsSection';
import CaseStudies from '../../components/CaseStudies/CaseStudies';
import ContactArea from '../../components/ContactArea';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';

const HomePage = () => {
    return (
        <Fragment>
            <Navbar hclass={'wpo-header-style-1'} topbarNone={'topbar-none'}/>
            <Hero/>
            <PainPoints/>
            <ServiceSection/>
            <ResultsSection/>
            <CaseStudies/>
            <ContactArea/>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    );
};

export default HomePage;
